import Script from 'next/script'

type Props = {
  className?: string
}
export const InstreamAd: React.FC<Props> = ({ className = '' }) => {
  return (
    <div className={className}>
      <div
        id="071a58e4-6f51-4d5e-a75e-fe14f0100a7a"
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="_ap_apex_ad"
        // eslint-disable-next-line react/no-unknown-property
        max-height="360"
      >
        <Script
          id="instreamad-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
(function(w, d) {
	var s = d.createElement('script');
	s.src = 'https://cdn.adpushup.com/47293/adpushup.js';
	s.crossOrigin='anonymous'; 
	s.type = 'text/javascript'; s.async = true;
	(d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(s);
	w.adpushup = w.adpushup || {que:[]};

	w.adpushup.que.push(function() {
		w.adpushup.triggerAd("071a58e4-6f51-4d5e-a75e-fe14f0100a7a");
	});
})(window, document);
`,
          }}
        />
      </div>
    </div>
  )
}
